import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import { currencyFormat } from '../utils/currency';
import { curtText } from '../utils/text';

export const reportPDFVentas = (empresa = {}, config = {}) => {
  const sucursal = empresa?.sucursales?.find(sucursal => sucursal.id_sucursal === empresa?.sucursal );
  const pdf = new jsPDF('landscape', 'mm', [330, 215.9]);

  const rowsPerPage = 27;
  const numberPages = Math.ceil(empresa?.ventas?.length / rowsPerPage);

  const pagesVentas = [];
  const totales = [];
  const parciales = [];
  // partir en paginas las compras
  for (let j = 0; j < numberPages; j++) {
    pagesVentas.push(empresa?.ventas?.slice(j*rowsPerPage, j*rowsPerPage+rowsPerPage));
  }
  // sacar los totales por pagina
  for (let z = 0; z < numberPages; z++) {
    const totalPage = pagesVentas[z].reduce((a,b)=>{
      return {
        importe:(parseFloat(a.importe) +parseFloat(b.importe)).toFixed(2),
        ice:(parseFloat(a.ice) +parseFloat(b.ice)).toFixed(2),
        iehd:(parseFloat(a.iehd) +parseFloat(b.iehd)).toFixed(2),
        ipj:(parseFloat(a.ipj) +parseFloat(b.ipj)).toFixed(2),
        tasas:(parseFloat(a.tasas) +parseFloat(b.tasas)).toFixed(2),
        otros_no_dfiva:(parseFloat(a.otros_no_dfiva) +parseFloat(b.otros_no_dfiva)).toFixed(2),
        exportaciones:(parseFloat(a.exportaciones) +parseFloat(b.exportaciones)).toFixed(2),
        tasa_cero:(parseFloat(a.tasa_cero) +parseFloat(b.tasa_cero)).toFixed(2),
        subtotal:(parseFloat(a.subtotal) +parseFloat(b.subtotal)).toFixed(2),
        descuentos:(parseFloat(a.descuentos) +parseFloat(b.descuentos)).toFixed(2),
        gift_card:(parseFloat(a.gift_card) +parseFloat(b.gift_card)).toFixed(2),
        base_dfiva:(parseFloat(a.base_dfiva) +parseFloat(b.base_dfiva)).toFixed(2),
        dfiva:(parseFloat(a.dfiva) +parseFloat(b.dfiva)).toFixed(2),
        }
      }
    );
    totales.push(totalPage);
  }

  // sacar los parciales por pagina
  parciales.push({...totales[0]});
  for (let i = 1; i < numberPages; i++) {
    parciales.push({
      importe: (parseFloat(parciales[i-1].importe) + parseFloat(totales[i].importe)).toFixed(2),
      ice: (parseFloat(parciales[i-1].ice) + parseFloat(totales[i].ice)).toFixed(2),
      iehd: (parseFloat(parciales[i-1].iehd) + parseFloat(totales[i].iehd)).toFixed(2),
      ipj: (parseFloat(parciales[i-1].ipj) + parseFloat(totales[i].ipj)).toFixed(2),
      tasas: (parseFloat(parciales[i-1].tasas) + parseFloat(totales[i].tasas)).toFixed(2),
      otros_no_dfiva: (parseFloat(parciales[i-1].otros_no_dfiva) + parseFloat(totales[i].otros_no_dfiva)).toFixed(2),
      exportaciones: (parseFloat(parciales[i-1].exportaciones) + parseFloat(totales[i].exportaciones)).toFixed(2),
      tasa_cero: (parseFloat(parciales[i-1].tasa_cero) + parseFloat(totales[i].tasa_cero)).toFixed(2),
      subtotal: (parseFloat(parciales[i-1].subtotal) + parseFloat(totales[i].subtotal)).toFixed(2),
      descuentos: (parseFloat(parciales[i-1].descuentos) + parseFloat(totales[i].descuentos)).toFixed(2),
      gift_card: (parseFloat(parciales[i-1].gift_card) + parseFloat(totales[i].gift_card)).toFixed(2),
      base_dfiva: (parseFloat(parciales[i-1].base_dfiva) + parseFloat(totales[i].base_dfiva)).toFixed(2),
      dfiva: (parseFloat(parciales[i-1].dfiva) + parseFloat(totales[i].dfiva)).toFixed(2),
    });
  }
  

  const headerPDF = () => {
    pdf.setFont("Lato", "bold");
    pdf.setFontSize(16)
    pdf.text(130, 10, 'REGISTRO DE VENTAS');
    pdf.setFontSize(11)
    pdf.text(150, 15, `${config.month}/${config.year}`);
    
    pdf.setFontSize(12);
    pdf.setFont("Lato", "bold");
    pdf.text(10, 22, "NIT: ");
    pdf.setFont("Lato", "normal");
    pdf.text(20, 22, empresa.nit);
    pdf.setFont("Lato", "bold");
    pdf.text(50, 22, "RAZON SOCIAL: ");
    pdf.setFont("Lato", "normal");
    pdf.text(85, 22, curtText(empresa.razon_social, 35));
    pdf.setFont("Lato", "bold");
    pdf.text(180, 22, "SUCURSAL: ");
    pdf.setFont("Lato", "normal");
    pdf.text(205, 22, curtText(`${sucursal?.codigo} - ${sucursal?.zona} - ${sucursal?.direccion}`, 50));
  }
  const bodyPDF = (pageNumber = 1) => {
    pdf.autoTable({
      head: headerTable(),
      body: bodyTable(pageNumber),
      foot: footerTable(pageNumber),
      startY: 25,
      theme: 'grid',
      margin: { top: 0, left: 5, bottom: 0, right: 5 },
      headStyles,
      bodyStyles,
      footStyles,
      columnStyles
    });
  }
  const footerPDF = (pageNumber = 1) => {
    pdf.setFontSize(10);
    pdf.setFont("Lato", "bold");
    pdf.text(10, 209, "TITULAR: ");
    pdf.setFont("Lato", "normal");
    pdf.text(30, 209, curtText(empresa.responsable, 35))
    pdf.setFont("Lato", "bold");
    pdf.text(120, 209, "CI: ")
    pdf.setFont("Lato", "normal");
    pdf.text(130, 209, empresa.ci)
    if(numberPages > 1) {
      pdf.text(300, 209, `PÁGINA ${pageNumber+1}/${numberPages}`);
    }
  }

  const headerTable = () => (
    [
      [
        'N',
        'FECHA',
        'NIT',
        'RAZON SOCIAL',
        'FACTURA',
        'EXP',
        'AUTORIZACION',
        'TOTAL',
        'ICE',
        'IEHD',
        'IPJ',
        'TASAS',
        'NODFIVA',
        'EXENTOS',
        'TASACERO',
        'SUBTOTAL',
        "DESC",
        "GIFTCARD",
        'BASE DFIVA',
        'DFIVA',
        'EST',
        'TIPO',
        'CODIGO CONTROL'
      ]
    ]
  );

  const bodyTable = (pageNumber = 1) => {
    const body = [];
    pagesVentas[pageNumber]?.forEach((venta, index) => {
      body.push([
        { content: index + 1 + rowsPerPage * pageNumber },
        { content: moment(venta.fecha, "YYYY-MM-DD").format("DD/MM/YYYY") },
        { content: venta.nit, styles: { halign: 'right' } },
        { content: curtText(venta.razon_social, 20), styles: { halign: 'left' } },
        { content: venta.factura, styles: { halign: 'right' } },
        { content: venta.complemento ? venta.complemento: "" , styles: { halign: 'right' } },
        { content: curtText(venta.autorizacion, 15), styles: { halign: 'right' } },
        { content: currencyFormat(venta.importe), styles: { halign: 'right' } },
        { content: currencyFormat(venta.ice), styles: { halign: 'right' } },
        { content: currencyFormat(venta.iehd), styles: { halign: 'right' } },
        { content: currencyFormat(venta.ipj), styles: { halign: 'right' } },
        { content: currencyFormat(venta.tasas), styles: { halign: 'right' } },
        { content: currencyFormat(venta.otros_no_dfiva), styles: { halign: 'right' } },
        { content: currencyFormat(venta.exportaciones), styles: { halign: 'right' } },
        { content: currencyFormat(venta.tasa_cero), styles: { halign: 'right' } },
        { content: currencyFormat(venta.subtotal), styles: { halign: 'right' } },
        { content: currencyFormat(venta.descuentos), styles: { halign: 'right' } },
        { content: currencyFormat(venta.gift_card), styles: { halign: 'right' } },
        { content: currencyFormat(venta.base_dfiva), styles: { halign: 'right' } },
        { content: currencyFormat(venta.dfiva), styles: { halign: 'right' } },
        { content: venta.estado, styles: { halign: 'right' } },
        { content: venta.tipo_venta, styles: { halign: 'right' } },
        { content: venta.codigo_control, styles: { halign: 'right' } }
      ]);
    });


    if(numberPages > 0) {
      // x = 10 - (12 % 10) = 8
      if(pageNumber + 1 === numberPages && empresa?.ventas?.length % rowsPerPage !== 0) {
        //  x = 3 - 12 % 3 = 3
        const rowsToAdd = rowsPerPage - (empresa?.ventas?.length % rowsPerPage);
        for (let i = 1; i <= rowsToAdd; i++) {
          body.push({ content: '' });
        }
      }
    }else {
      const rowsToAdd = rowsPerPage - (empresa?.ventas?.length % rowsPerPage);
      for (let i = 1; i <= rowsToAdd; i++) {
        body.push({ content: '' });
      }
    }
    return body;
  }

  const footerTable = (pageNumber = 1) => {
    let endPage  = pageNumber + 1 === numberPages;
    if(!numberPages) {
      endPage = true;
    }
    return [
      [
        { content: 'TOTAL PAGINA',colSpan: 7,styles: { halign: 'right' }},
        { content: currencyFormat(totales[pageNumber]?.importe || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.ice || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.iehd || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.ipj || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.tasas || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.otros_no_dfiva || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.exportaciones || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.tasa_cero || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.subtotal || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.descuentos || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.gift_card || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.base_dfiva || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(totales[pageNumber]?.dfiva || "0.00"), styles: { halign: 'right' } },
      ],
      [
        {
          content: endPage?'TOTAL VENTAS' :'TOTAL PARCIAL', colSpan: 7, styles: { halign: 'right' }
        },
        { content: currencyFormat(parciales[pageNumber]?.importe || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.ice || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.iehd || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.ipj || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.tasas || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.otros_no_dfiva || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.exportaciones || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.tasa_cero || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.subtotal || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.descuentos || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.gift_card || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.base_dfiva || "0.00"), styles: { halign: 'right' } },
        { content: currencyFormat(parciales[pageNumber]?.dfiva || "0.00"), styles: { halign: 'right' } }
      ]
    ];
  }


  for (let i = 0; i < numberPages; i++) {
      // HEADER
    headerPDF();
    // BODY
    bodyPDF(i);
    // FOOTER
    footerPDF(i);

    if(i === numberPages-1) continue;
    pdf.addPage();
  }

  if(!numberPages) {
    headerPDF();
    bodyPDF();
    footerPDF();
    pdf.setFontSize(40);
    pdf.setTextColor("Gray");
    pdf.text(100, 115, `SIN MOVIMIENTO`);
  }

  return pdf.output('datauristring');
}

const headStyles = {
  fontSize: 6,
  valign: 'middle',
  halign: 'center',
  fillColor: [0, 0, 0],
  textColor: [255, 255, 255],
  font: "Lato"
};

const bodyStyles = {
  fontSize: 6,
  valign: 'middle',
  halign: 'center',
  font: "Lato",
};

const footStyles = {
  fontSize: 7,
  valign: 'middle',
  halign: 'center',
  fillColor: [0, 0, 0],
  textColor: [255, 255, 255]
};

const columnStyles = {
};